import { useMemo, useState } from 'react'
import * as ClientHttp from '../../../../../../services/api/https/registration/client.http'
import { getGeocode } from '../../../../../../services/Maps'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  UPDATE_CUSTOMER: 'Atualizando cliente',
  FIND_ALL_COORDINATES: 'Encontrando as coordenadas de todos os clientes',
}

const INITIAL_STATE = {
  customers: [],
  globalFilter: '',
  showModal: false,
  selectedCustomer: null,
  updatedCustomer: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  successMessage: null,
}

export default function useClienteSemCoordenada() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          successMessage: null,
        }))
      },

      async findAllCoordinates(customers) {
        const failedCustomers = []
        const updatedIds = []

        for (const customer of customers) {
          try {
            const { deliveries, ...cliente } = customer
            const res = await getGeocode(
              `${cliente.address}, ${cliente.number}, ${cliente.district}, ${cliente.city}-${cliente.uf_id}, Brasil`,
            )
            if (!res || !res.lng) throw new Error('Endereço não encontrado')

            await ClientHttp.updateClient({ ...cliente, latitude: res.lat, longitude: res.lng })
            updatedIds.push(customer.id)
          } catch (err) {
            failedCustomers.push(customer)
          }
        }

        setState(prevState => ({
          ...prevState,
          customers: prevState.customers.filter(cust => !updatedIds.includes(cust.id)),
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage:
            failedCustomers.length > 0
              ? `Não foi possível cadastrar automaticamente as coordenadas do(s) cliente(s): ${failedCustomers
                  .map(cust => cust.nomeFantasia)
                  .join(', ')}`
              : null,
          successMessage:
            failedCustomers.length === 0
              ? 'Coordenadas de todos os clientes cadastradas com sucesso!'
              : null,
        }))
      },

      //Events
      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onInit(customers) {
        setState(prevState => ({ ...prevState, customers: customers }))
      },

      onFindAllClicked() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.FIND_ALL_COORDINATES,
        }))
      },

      onRowClicked(customer) {
        setState(prevState => ({ ...prevState, showModal: true, selectedCustomer: customer }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, showModal: false, selectedCustomer: null }))
      },

      onModalSave(customer) {
        setState(prevState => {
          prevState.showModal = false
          prevState.selectedCustomer = null
          prevState.customers = prevState.customers.filter(cust => cust.id !== customer.id)
          prevState.updatedCustomer = customer
          prevState.loadingMessage = LOAD_MESSAGE.UPDATE_CUSTOMER
          return { ...prevState }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
